import { render } from "./ScreenQuestionTwoButtons.vue?vue&type=template&id=61c5cb4e&ts=true"
import script from "./ScreenQuestionTwoButtons.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionTwoButtons.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__